"use client";

import useSWR from "swr";
import type { TenantSettings } from "@/types";

export function useSettings() {
  const { data, error, isLoading, mutate } = useSWR<Partial<TenantSettings>>(
    "/api/tenants/settings",
    { revalidateOnFocus: false }
  );

  return {
    settings: data ?? null,
    isLoading,
    error,
    mutate,
  };
}
